import NewsSVG from '../../assets/svg/news.svg';
export default NewsSVG;
